import { Component } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.css'
})
export class ContactComponent {
  bookSession(){
    window.location.href='https://stefanyrosemberg.janeapp.com';
  }
}
